class DeductionsController {
    init() {
        console.log("deductions init!");
    }

    index() {
        console.log("deductions index!");
    }

    edit() {
        deductionsOnEditOrNew();
    }

    new() {
        console.log("deductions new!");
        deductionsOnEditOrNew();
    }
}

window.BC = window.BC || {};
window.BC.deductions = new DeductionsController();

function deductionsOnEditOrNew() {
    blurToCurrency(0, [
        '#deduction_split'
    ]);
    blurToCurrency(2, [
        '#deduction_legal',
        '#deduction_foundation_base',
        '#deduction_foundation',
        '#deduction_agent_charges',
        '#deduction_broker_expense'
    ]);
    blurToPercentage(0, [
        '#deduction_tax_pct',
        '#deduction_retirement_pct'
    ]);
    blurToPercentage(3, [
        '#deduction_state_b_and_o',
        '#deduction_city_b_and_o'
    ]);
}